import styled from "styled-components";
import NavBar from "../../../Componentes/NavBar";
import useApi from "../../../hooks/useApi";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { formatBRLFromCents } from "../../../Funcoes/Money";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { useModal } from "../../../contexts/ModalContext";
import SidebarFaturamentoDireto from "./SidebarFaturamentoDireto";
import ModalAdicionarPCFaturamentoDireto from "./ModalAdicionarPCFaturamentoDireto";
import ModalNovaNFFaturamentoDireto from "./ModalNovaNFFaturamentoDireto";
import ModalListaNFFaturamentoDireto from "./ModalListaNFFaturamentoDireto";
import ModalEditarPCFaturamentoDireto from "./ModalEditarPCFaturamentoDireto";
import ModalAnexosFaturamentoDireto from "./ModalAnexosFaturamentoDireto";
import { FiEdit2, FiPaperclip, FiPlus, FiSearch } from "react-icons/fi";

const PageContainer = styled.div`
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    background-color: #242d34;
`;

const BodyOuter = styled.div`
    width: 100%;
    flex: 1;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 15px;
`;

const Header = styled.div`
    width: 100%;
    min-height: 120px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    background-color: #fff;
    border-radius: 15px;
    padding: 15px;
    box-sizing: border-box;
`;

const InfoWrapper = styled.div`
    flex: 1 1 160px;
    min-width: 0;
    max-width: 280px;
    height: 100%;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: #f0f0f0;
    border-radius: 15px;
    p {
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        margin-left: 20px;
    }
    h3 {
        font-size: 12px;
        color: #555;
        margin: 0;
        margin-left: 20px;
        line-height: 1.25;
    }
`;

const TabelaWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #fff;
    border-radius: 15px;
    overflow: auto;
`;

const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 2;
    }
    tbody {
        tr {
            border-bottom: 1px solid #ccc;
            &:nth-child(even) {
                background-color: #fafafa;
            }
            &:hover {
                background-color: #e0f7fa;
            }
        }
        td:first-of-type {
            padding-left: 24px;
        }
        td {
            padding-top: 8px;
            padding-bottom: 8px;
        }
    }
`;

const LinhaCabecalho = styled.tr`
    height: 45px;
`;

const ColunaCabecalho = styled.th`
    text-align: left;
    padding: 0 12px 0 24px;
    color: #242d34;
    font-size: 15px;
`;

const TabelaInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    & p {
        margin: 0;
    }
    margin: 10px 0;
`;

const ColunaAcoes = styled.td`
    width: auto;
    white-space: nowrap;
    padding: 0 10px 0 0;
    box-sizing: border-box;
`;

const AcoesWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 14px;
    margin: 0;
`;

const IconeWrapper = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;

const IconeAdicionar = styled(FiPlus)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`;

const IconeAdicionarInativo = styled(FiPlus)`
    color: #ccc;
    font-size: 30px;
    cursor: not-allowed;
`;

const IconePesquisar = styled(FiSearch)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`;

const IconeEditar = styled(FiEdit2)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`;

const IconeEditarInativo = styled(FiEdit2)`
    color: #ccc;
    font-size: 30px;
    cursor: not-allowed;
`;

const IconeAnexo = styled(FiPaperclip)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`;

const IconeAnexoInativo = styled(FiPaperclip)`
    color: #ccc;
    font-size: 30px;
    cursor: not-allowed;
`;

const LoadingContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const LoadingWrapper = styled.div`
    width: 350px;
    height: 120px;
    background-color: #f0f0f0;
    border-radius: 10px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const FaturamentoDireto = () => {

    const { id } = useParams();
    const api = useApi();
    const { isModalOpen, openModal } = useModal();

    const [faturamentoParaNovaNf, setFaturamentoParaNovaNf] = useState(null);
    const [faturamentoParaListaNf, setFaturamentoParaListaNf] = useState(null);
    const [faturamentoParaEditar, setFaturamentoParaEditar] = useState(null);
    const [faturamentoParaAnexos, setFaturamentoParaAnexos] = useState(null);

    const handleOpenSidebar = () => {

        openModal("sidebarFaturamentoDireto");

    };

    const [loading, setLoading] = useState(true);
    const [valorFatDireto, setValorFatDireto] = useState(0);
    const [numPedido, setNumPedido] = useState("");
    const [itensFaturamentoDireto, setItensFaturamentoDireto] = useState([]);

    const somaPedidoCompra = useMemo(
        () =>
            itensFaturamentoDireto.reduce(
                (acc, row) => acc + (Number(row.valor) || 0),
                0
            ),
        [itensFaturamentoDireto]
    );

    const saldoPedidoCompra = useMemo(
        () => valorFatDireto - somaPedidoCompra,
        [valorFatDireto, somaPedidoCompra]
    );

    const somaNotaFiscal = useMemo(
        () =>
            itensFaturamentoDireto.reduce(
                (acc, row) => acc + (Number(row.soma_nf) || 0),
                0
            ),
        [itensFaturamentoDireto]
    );

    const saldoNotaFiscal = useMemo(
        () => valorFatDireto - somaNotaFiscal,
        [valorFatDireto, somaNotaFiscal]
    );

    const abrirModalNovaNf = (linha) => {

        setFaturamentoParaNovaNf(linha);
        openModal("modalNovaNFFatDireto");

    };

    const abrirModalListaNf = (linha) => {

        setFaturamentoParaListaNf(linha ?? null);
        openModal("modalListaNfFatDireto");

    };

    const abrirModalEditar = (linha) => {

        setFaturamentoParaEditar(linha);
        openModal("modalEditarPCFaturamentoDireto");

    };

    const abrirModalAnexos = (linha) => {

        setFaturamentoParaAnexos(linha);
        openModal("modalAnexosFatDireto");

    };

    const recarregarItens = async () => {

        try {

            const { data: listaData } = await api.get(
                `/Painel/API/ControleMedicao/ListPcFaturamentoDireto/index.php?id_pc=${id}`
            );
            setItensFaturamentoDireto(Array.isArray(listaData?.itens) ? listaData.itens : []);

        } catch (e) {

            console.error(e);

        }

    };

    useEffect(() => {

        const carregar = async () => {

            setLoading(true);

            try {

                const { data: pedidoData } = await api.get(
                    `/Painel/API/ControleMedicao/PedidoInfo/index.php?id=${id}`
                );
                setValorFatDireto(Number(pedidoData?.soma_faturamento_direto) || 0);
                setNumPedido(
                    pedidoData?.num_pedido ??
                        pedidoData?.pedido_compra?.num_pedido ??
                        ""
                );

            } catch (e) {

                console.error(e);
                setValorFatDireto(0);
                setNumPedido("");

            }

            try {

                const { data: listaData } = await api.get(
                    `/Painel/API/ControleMedicao/ListPcFaturamentoDireto/index.php?id_pc=${id}`
                );
                setItensFaturamentoDireto(Array.isArray(listaData?.itens) ? listaData.itens : []);

            } catch (e) {

                console.error(e);
                setItensFaturamentoDireto([]);

            } finally {

                setLoading(false);

            }

        };

        carregar();

    }, [id]);

    return (
        <>
            <PageContainer>
                <NavBar
                    navTo="/modulo/controle-medicao/pedidos-compra"
                    setSideBar={handleOpenSidebar}
                />
                <BodyOuter>
                <Header>
                    <InfoWrapper>
                        <p>
                            {loading ? "—" : formatBRLFromCents(valorFatDireto)}
                        </p>
                        <h3>VALOR FAT. DIRETO</h3>
                    </InfoWrapper>
                    <InfoWrapper>
                        <p>
                            {loading
                                ? "—"
                                : formatBRLFromCents(somaPedidoCompra)}
                        </p>
                        <h3>SOMA PEDIDO COMPRA</h3>
                    </InfoWrapper>
                    <InfoWrapper>
                        <p>
                            {loading
                                ? "—"
                                : formatBRLFromCents(somaNotaFiscal)}
                        </p>
                        <h3>SOMA NOTA FISCAL</h3>
                    </InfoWrapper>
                    <InfoWrapper>
                        <p>
                            {loading
                                ? "—"
                                : formatBRLFromCents(saldoPedidoCompra)}
                        </p>
                        <h3>SALDO PEDIDO COMPRA</h3>
                    </InfoWrapper>
                    <InfoWrapper>
                        <p>
                            {loading
                                ? "—"
                                : formatBRLFromCents(saldoNotaFiscal)}
                        </p>
                        <h3>SALDO NOTA FISCAL</h3>
                    </InfoWrapper>
                </Header>
                <TabelaWrapper>
                    {loading ? (
                        <LoadingContainer>
                            <LoadingWrapper>
                                <SmallLoading />
                            </LoadingWrapper>
                        </LoadingContainer>
                    ) : (
                        <Tabela>
                            <thead>
                                <LinhaCabecalho>
                                    <ColunaCabecalho colSpan={3}>
                                        FATURAMENTO DIRETO — PC Nº {numPedido || "—"}
                                    </ColunaCabecalho>
                                </LinhaCabecalho>
                            </thead>
                            <tbody>
                                {itensFaturamentoDireto.length === 0 ? (
                                    <tr>
                                        <td colSpan={2}>
                                            <TabelaInfoWrapper>
                                                <p style={{ color: "#666" }}>
                                                    Nenhum registro de faturamento direto para este pedido.
                                                </p>
                                            </TabelaInfoWrapper>
                                        </td>
                                        <ColunaAcoes>
                                            <AcoesWrapper>
                                                <IconeWrapper title="Adicione um faturamento direto para incluir NF">
                                                    <IconeAdicionarInativo aria-label="Adicionar NF" />
                                                </IconeWrapper>
                                                <IconeWrapper title="Ver NFs do pedido de compra">
                                                    <IconePesquisar
                                                        aria-label="Ver notas fiscais"
                                                        onClick={() => abrirModalListaNf(null)}
                                                    />
                                                </IconeWrapper>
                                                <IconeWrapper title="Anexos da linha de faturamento direto">
                                                    <IconeAnexoInativo aria-label="Anexos" />
                                                </IconeWrapper>
                                                <IconeWrapper title="Adicione um faturamento direto para editar">
                                                    <IconeEditarInativo aria-label="Editar" />
                                                </IconeWrapper>
                                            </AcoesWrapper>
                                        </ColunaAcoes>
                                    </tr>
                                ) : (
                                    itensFaturamentoDireto.map((row) => (
                                        <tr key={row.id}>
                                            <td>
                                                <TabelaInfoWrapper>
                                                    <p>
                                                        <b>DISCIPLINA:</b> {row.disciplina || "—"}
                                                    </p>
                                                    <p>
                                                        <b>Nº PEDIDO / FORNEC.:</b> {row.num_pedido_fornec || "—"}
                                                    </p>
                                                    <p>
                                                        <b>VALOR:</b>{" "}
                                                        {formatBRLFromCents(Number(row.valor) || 0)}
                                                    </p>
                                                    <p>
                                                        <b>SALDO PEDIDO:</b>{" "}
                                                        {formatBRLFromCents(Number(row.saldo_pedido) || 0)}
                                                    </p>
                                                </TabelaInfoWrapper>
                                            </td>
                                            <td>
                                                <TabelaInfoWrapper>
                                                    <p>
                                                        <b>FORNECEDOR:</b> {row.fornecedor || "—"}
                                                    </p>
                                                </TabelaInfoWrapper>
                                            </td>
                                            <ColunaAcoes>
                                                <AcoesWrapper>
                                                    <IconeWrapper title="Adicionar NF">
                                                        <IconeAdicionar
                                                            aria-label="Adicionar NF"
                                                            onClick={() => abrirModalNovaNf(row)}
                                                        />
                                                    </IconeWrapper>
                                                    <IconeWrapper title="Ver NFs deste pedido / fornecimento">
                                                        <IconePesquisar
                                                            aria-label="Ver notas fiscais"
                                                            onClick={() => abrirModalListaNf(row)}
                                                        />
                                                    </IconeWrapper>
                                                    <IconeWrapper title="Ver e gerenciar anexos">
                                                        <IconeAnexo
                                                            aria-label="Anexos"
                                                            onClick={() => abrirModalAnexos(row)}
                                                        />
                                                    </IconeWrapper>
                                                    <IconeWrapper title="Editar linha de faturamento direto">
                                                        <IconeEditar
                                                            aria-label="Editar"
                                                            onClick={() => abrirModalEditar(row)}
                                                        />
                                                    </IconeWrapper>
                                                </AcoesWrapper>
                                            </ColunaAcoes>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Tabela>
                    )}
                </TabelaWrapper>
                </BodyOuter>
            </PageContainer>
            {
                isModalOpen("sidebarFaturamentoDireto") && (
                    <SidebarFaturamentoDireto />
                )
            }
            {
                isModalOpen("modalAdicionarPCFaturamentoDireto") && (
                    <ModalAdicionarPCFaturamentoDireto onSalvo={recarregarItens} />
                )
            }
            {
                isModalOpen("modalNovaNFFatDireto") && faturamentoParaNovaNf && (
                    <ModalNovaNFFaturamentoDireto
                        faturamento={faturamentoParaNovaNf}
                        onFechar={() => setFaturamentoParaNovaNf(null)}
                        onSalvo={recarregarItens}
                    />
                )
            }
            {
                isModalOpen("modalListaNfFatDireto") && (
                    <ModalListaNFFaturamentoDireto
                        numPedido={numPedido}
                        faturamento={faturamentoParaListaNf}
                        onFechar={() => setFaturamentoParaListaNf(null)}
                        onAlterado={recarregarItens}
                    />
                )
            }
            {
                isModalOpen("modalEditarPCFaturamentoDireto") && faturamentoParaEditar && (
                    <ModalEditarPCFaturamentoDireto
                        faturamento={faturamentoParaEditar}
                        onFechar={() => setFaturamentoParaEditar(null)}
                        onSalvo={recarregarItens}
                    />
                )
            }
            {
                isModalOpen("modalAnexosFatDireto") && faturamentoParaAnexos && (
                    <ModalAnexosFaturamentoDireto
                        faturamento={faturamentoParaAnexos}
                        numPedido={numPedido}
                        onFechar={() => setFaturamentoParaAnexos(null)}
                    />
                )
            }
        </>
    );

};

export default FaturamentoDireto;
